

// theme.liquid,300行代码，需要移植


document.addEventListener('DOMContentLoaded', function() {
    // 1. 获取所有需要的元素
    const headerLogoWrapper = document.querySelector(".shopify-section.shopify-section-group-header-group.section-header");
    const headerWhiteLogo = document.querySelector(".logo-svg-img-white");
    const headerBlackLogo = document.querySelector(".logo-svg-img-black");
    const announcementBar = document.querySelector(".shopify-section.announcement-bar-section.shopify-section-group-header-group");
    const homePageFirstElement = document.querySelector("#MainContent > *:first-child");
    const allFirstTabs=Array.from(document.querySelectorAll(".header-tab-como-firstTitle"));
    const allFirstTabSvg=Array.from(document.querySelectorAll(".icon.icon-caret"));
    const searchIcon=document.querySelector(".header-icon-search-pc-wrapper   .como-header-1011.header__search  .header__icon--search.header__icon--summary.focus-inset");

     
     const svgWrapperComoColors=Array.from(document.querySelectorAll(".svg-wrapper-como-color"));

    // 使用标签选择器 'sticky-header'
    const stickyHeader = headerLogoWrapper ? headerLogoWrapper.querySelector('sticky-header') : null;

     if(window.innerWidth<990){
        return;
     }

    // 2. 检查所有关键元素是否存在
    if (  !headerLogoWrapper || !announcementBar ) {
     
        return;
    }

   

     const announcementBarHeight = announcementBar.offsetHeight;
        const firstElementHeight = homePageFirstElement.offsetHeight;

    // 3. 只在首页执行滚动效果
    if (window.pageTemplateName === 'index' ) {

    //新添加的
    const header=document.querySelector('.header-wrapper--border-bottom');
  const linkFont=document.querySelectorAll('.header-tab-como-firstTitle')
  const iconColor=document.querySelectorAll('.icon-caret path')
  const iconColor2=document.querySelectorAll('.svg-wrapper-como-color path')
  const whiteLogo=document.querySelector('.logo-svg-img-white')
  const blackLogo=document.querySelector('.logo-svg-img-black')
       

        // 如果渐变的触发元素高度为0，则不执行
        if (firstElementHeight <= 0) return;

        // 用来检测首页的导航栏激活后，字体变成黑色
        const clickTabBackground=()=>{
            allFirstTabs.forEach((item,index)=>{
                    item.addEventListener("click",()=>{
                        const parentElement = item.parentElement;
                        if (parentElement && parentElement.tagName === 'SUMMARY' && parentElement.getAttribute('aria-expanded') == 'false'){
                                // stickyHeader.style.backgroundColor = "rgba(255,255,255,1)";
                                                           header.style.background="transparent"
      linkFont.forEach(p=>{
        p.style.color="#fff"
      })
      iconColor.forEach(p=>{
        p.style.fill="#fff"
      })
      iconColor2.forEach(p=>{
        p.style.fill="#fff"
      })

                                   headerWhiteLogo.style.display = 'none';
                                  headerBlackLogo.style.display = 'block';

                                allFirstTabs.forEach((item,index)=>{
                                        item.classList.remove("activeTab");
                                    })
                                    
                                    allFirstTabSvg.forEach((item,index)=>{
                                        item.classList.remove("activeTab");
                                    })

                                    svgWrapperComoColors.forEach((item,index)=>{
                                        item.classList.remove("activeTab");
                                    })

                                    // console.log("被点击了-----变色");

                            }else if(parentElement && parentElement.tagName === 'SUMMARY' && parentElement.getAttribute('aria-expanded') == 'true'){
                                // stickyHeader.style.backgroundColor = "transparent";
     

                                  headerWhiteLogo.style.display = 'block';
                                  headerBlackLogo.style.display = 'none';

                                 allFirstTabs.forEach((item,index)=>{
                                        item.classList.add("activeTab");
                                    })
                                    
                                    allFirstTabSvg.forEach((item,index)=>{
                                        item.classList.add("activeTab");
                                    })

                                    svgWrapperComoColors.forEach((item,index)=>{
                                        item.classList.add("activeTab");
                                    })
                                // console.log("被点击了-----不变色");
                            }
                    })
              })

            searchIcon.addEventListener("click",()=>{
                     const parentElement = searchIcon.parentElement;
                     if (parentElement && parentElement.tagName === 'DETAILS' && parentElement.getAttribute('open') == 'true'){
                            //  stickyHeader.style.backgroundColor = "rgba(255,255,255,1)";

                                   headerWhiteLogo.style.display = 'none';
                                  headerBlackLogo.style.display = 'block';

                                allFirstTabs.forEach((item,index)=>{
                                        item.classList.remove("activeTab");
                                    })
                                    
                                    allFirstTabSvg.forEach((item,index)=>{
                                        item.classList.remove("activeTab");
                                    })

                                    svgWrapperComoColors.forEach((item,index)=>{
                                        item.classList.remove("activeTab");
                                    })
                                    header.style.background="#fff"
      linkFont.forEach(p=>{
        p.style.color="#000"
      })
      iconColor.forEach(p=>{
        p.style.fill="#000"
      })
      iconColor2.forEach(p=>{
        p.style.fill="#000"
      })
      whiteLogo.style.display="none"
      blackLogo.style.display="block"

                                      console.log("被点击了-----不变色--Como123");

                     }else if(parentElement && parentElement.tagName === 'DETAILS' && !parentElement.hasAttribute('open')){
                            //  stickyHeader.style.backgroundColor = "transparent";

                                  headerWhiteLogo.style.display = 'block';
                                  headerBlackLogo.style.display = 'none';

                                 allFirstTabs.forEach((item,index)=>{
                                        item.classList.add("activeTab");
                                    })
                                    
                                    allFirstTabSvg.forEach((item,index)=>{
                                        item.classList.add("activeTab");
                                    })

                                    svgWrapperComoColors.forEach((item,index)=>{
                                        item.classList.add("activeTab");
                                    })
                                console.log("被点击了-----不变色--Como");
                     }
            })
       
        }
       

        const handleScroll = () => {
            const scrollY = window.scrollY;

         
            const scrollPastAnnounceBar = Math.max(0, scrollY - announcementBarHeight);

           
            const progress = Math.min(scrollPastAnnounceBar / firstElementHeight, 1);




           
            stickyHeader.style.backgroundColor = `rgba(255, 255, 255, ${progress})`;
           
           


            
            if (scrollY >= announcementBarHeight) {
              
                headerLogoWrapper.style.position = 'fixed';
                    headerLogoWrapper.style.left = "0";
                headerLogoWrapper.style.right = "0";
                headerLogoWrapper.style.top = '0px';
            
                 headerWhiteLogo.style.display = 'none';
                 headerBlackLogo.style.display = 'block';
                  headerBlackLogo.style.opacity = 1;

                allFirstTabs.forEach((item,index)=>{
                    item.classList.remove("activeTab");
                })
                
                 allFirstTabSvg.forEach((item,index)=>{
                    item.classList.remove("activeTab");
                })

                 svgWrapperComoColors.forEach((item,index)=>{
                    item.classList.remove("activeTab");
                })
                 
            } else {
              
                headerLogoWrapper.style.position = 'absolute';
                headerLogoWrapper.style.top = announcementBarHeight + 'px';
                headerLogoWrapper.style.left = "0";
                headerLogoWrapper.style.right = "0";

                 allFirstTabs.forEach((item,index)=>{
                    item.classList.add("activeTab");
                })

                 allFirstTabSvg.forEach((item,index)=>{
                    item.classList.add("activeTab");
                })

                  svgWrapperComoColors.forEach((item,index)=>{
                    item.classList.add("activeTab");
                })
            }

             if (scrollY <= firstElementHeight){
                 headerWhiteLogo.style.display = 'block';
                 headerBlackLogo.style.display = 'none';
             }else{
                  headerWhiteLogo.style.display = 'none';
                 headerBlackLogo.style.display = 'block';
             }

        };
        
        // 页面加载时立即执行一次，设置好初始状态
        handleScroll();
        clickTabBackground();

        // 为窗口添加滚动事件监听器
        window.addEventListener('scroll', handleScroll);

    } else {
       
        headerLogoWrapper.style.position = 'sticky';
       
          headerLogoWrapper.style.left = "0";
         headerLogoWrapper.style.right = "0";

         // b. 定义一个只处理 Header 上移的滚动函数
        const handleScrollNonHomepage = () => {
            const scrollY = window.scrollY;

            // 核心公式：计算 top 值，从 announcementBarHeight 平滑过渡到 0
            const newTop = Math.max(0, announcementBarHeight - scrollY);
            headerLogoWrapper.style.top = newTop + 'px';
        };

        // c. 页面加载时执行一次，并添加滚动监听
        handleScrollNonHomepage();
        window.addEventListener('scroll', handleScrollNonHomepage);
       
          
        stickyHeader.style.backgroundColor = 'white';

        if (headerWhiteLogo) headerWhiteLogo.style.display = 'none';
        if (headerBlackLogo) {
            headerBlackLogo.style.display = 'block';
            headerBlackLogo.style.opacity = '1';
        }
    }
});